import defaultIcons from '@newrelic/gatsby-theme-newrelic/src/icons/logo';
import androidColor from './logo/android-color';
import apache from './logo/apache';
import appleColor from './logo/apple-color';
import aws from './logo/aws';
import azure from './logo/azure';
import c from './logo/c';
import capacitor from './logo/capacitor';
import cordova from './logo/cordova';
import dotnet from './logo/dotnet';
import dotnetMaui from './logo/dotnet-maui';
import dropwizard from './logo/dropwizard';
import flutter from './logo/flutter';
import gcloud from './logo/gcloud';
import istio from './logo/istio';
import java from './logo/java';
import javascript from './logo/javascript';
import jmx from './logo/jmx';
import kafka from './logo/kafka';
import kamon from './logo/kamon';
import kubernetes from './logo/kubernetes';
import go from './logo/go';
import linux from './logo/linux';
import micrometer from './logo/micrometer';
import mongodb from './logo/mongodb';
import mssql from './logo/mssql';
import mysql from './logo/mysql';
import newrelic from './logo/newrelic';
import nginx from './logo/nginx';
import nodejs from './logo/nodejs';
import opencensus from './logo/opencensus';
import opentelemetry from './logo/opentelemetry';
import opentelemetryColor from './logo/opentelemetry-color';
import php from './logo/php';
import postgresql from './logo/postgresql';
import prometheus from './logo/prometheus';
import python from './logo/python';
import react from './logo/react';
import redis from './logo/redis';
import ruby from './logo/ruby';
import statsd from './logo/statsd';
import unity from './logo/unity';
import unrealEngine from './logo/unreal-engine';
import windows from './logo/windows';
import xamarin from './logo/xamarin';

export default {
  ...defaultIcons,
  'android-color': androidColor,
  apache,
  'apple-color': appleColor,
  aws,
  azure,
  c,
  capacitor,
  cordova,
  dotnet,
  'dotnet-maui': dotnetMaui,
  dropwizard,
  flutter,
  gcloud,
  istio,
  java,
  javascript,
  jmx,
  kafka,
  kamon,
  kubernetes,
  go,
  linux,
  micrometer,
  mongodb,
  mssql,
  mysql,
  newrelic,
  nginx,
  nodejs,
  opencensus,
  opentelemetry,
  'opentelemetry-color': opentelemetryColor,
  php,
  postgresql,
  prometheus,
  python,
  redis,
  ruby,
  react,
  statsd,
  unity,
  'unreal-engine': unrealEngine,
  windows,
  xamarin,
};
